import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getAuthConfig = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return {
    headers: {
      Authorization: `Bearer ${user?.token}`,
    },
  };
};

const getTrips = async (search = '', page = 1) => {
  const response = await axios.get(
    `${API_URL}/trips?search=${search}&page=${page}`,
    getAuthConfig()
  );
  return response.data;
};

const getTripById = async (id) => {
  const response = await axios.get(`${API_URL}/trips/${id}`, getAuthConfig());
  return response.data;
};

const createTrip = async (tripData) => {
  const response = await axios.post(`${API_URL}/trips`, tripData, getAuthConfig());
  return response.data;
};

const updateTrip = async (id, tripData) => {
  const response = await axios.put(`${API_URL}/trips/${id}`, tripData, getAuthConfig());
  return response.data;
};

const deleteTrip = async (id) => {
  await axios.delete(`${API_URL}/trips/${id}`, getAuthConfig());
};

const inviteUser = async (tripId, email, role) => {
  const response = await axios.post(
    `${API_URL}/trips/${tripId}/invite`,
    { email, role },
    getAuthConfig()
  );
  return response.data;
};

const generateShareLink = async (tripId) => {
  const response = await axios.post(
    `${API_URL}/trips/${tripId}/share`,
    {},
    getAuthConfig()
  );
  return response.data;
};

const getSharedTrip = async (shareLink) => {
  const response = await axios.get(`${API_URL}/trips/shared/${shareLink}`);
  return response.data;
};

const toggleFavorite = async (tripId) => {
  const response = await axios.post(
    `${API_URL}/trips/${tripId}/favorite`,
    {},
    getAuthConfig()
  );
  return response.data;
};

const shareViaEmail = async (tripId, email, message) => {
  const response = await axios.post(
    `${API_URL}/trips/${tripId}/share-email`,
    { email, message },
    getAuthConfig()
  );
  return response.data;
};

const tripService = {
  getTrips,
  getTripById,
  createTrip,
  updateTrip,
  deleteTrip,
  inviteUser,
  generateShareLink,
  getSharedTrip,
  toggleFavorite,
  shareViaEmail,
};

export default tripService;